import { render } from "./PrimaryTypeCard.vue?vue&type=template&id=3bca5499"
import script from "./PrimaryTypeCard.vue?vue&type=script&lang=js"
export * from "./PrimaryTypeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__